<template>
  <WidgetWrapper
    :title="$route.meta.title"
    :full-height="true"
    v-loading="fullscreenLoading"
  >
    <div id="form-container" class="pt-2">
      <el-form
        ref="elForm"
        size="medium"
        label-width="auto"
        :model="formData"
        :rules="validationRules"
        v-if="formData.hasOwnProperty('CompanyNames')"
      >
        <div class="border-l-4 pl-4 bg-gray-100 py-2 mb-4">
          <div class="w-full el-form-item__content flex">
            <div class="el-form-item__label-wrap w-20">
              <label
                for="Username"
                class="el-form-item__label"
                style="width: auto;"
                >Username
              </label>
            </div>
            <div class="font-bold ml-2">
              {{ formData.Username }}
            </div>
          </div>

          <div class="w-full el-form-item__content flex">
            <div class="el-form-item__label-wrap w-20">
              <label
                for="CustomerName"
                class="el-form-item__label"
                style="width: auto;"
                >Company
              </label>
            </div>
            <div class="font-bold ml-2">
              {{
                formData.CompanyNames.length > 0
                  ? formData.CompanyNames.join(', ')
                  : '-'
              }}
            </div>
          </div>

          <div class="w-full el-form-item__content flex">
            <div class="el-form-item__label-wrap w-20">
              <label
                for="RolesName"
                class="el-form-item__label"
                style="width: auto;"
                >Roles
              </label>
            </div>
            <div class="font-bold ml-2">
              {{
                formData.RolesName.length > 0
                  ? formData.RolesName.join(', ')
                  : '-'
              }}
            </div>
          </div>

          <div v-if="mode == 'view'">
            <div class="w-full el-form-item__content flex">
              <div class="el-form-item__label-wrap w-20">
                <label
                  for="Email"
                  class="el-form-item__label"
                  style="width: auto;"
                  >Email
                </label>
              </div>
              <div class="font-bold ml-2">
                {{ formData.Email }}
              </div>
            </div>
            <div class="w-full el-form-item__content flex">
              <div class="el-form-item__label-wrap w-20">
                <label
                  for="Address"
                  class="el-form-item__label"
                  style="width: auto;"
                  >Address
                </label>
              </div>
              <div class="font-bold ml-2">
                {{ formData.Address ? formData.Address : '-' }}
              </div>
            </div>
            <div class="w-full el-form-item__content flex mb-2">
              <div class="el-form-item__label-wrap w-20">
                <label
                  for="Fullname"
                  class="el-form-item__label"
                  style="width: auto;"
                  >Fullname
                </label>
              </div>
              <div class="font-bold ml-2">
                {{ formData.Fullname }}
              </div>
            </div>
          </div>
        </div>

        <el-form-item label="Fullname" prop="Fullname" v-if="mode == 'edit'">
          <el-input
            v-model="formData.Fullname"
            placeholder="Fullname"
            clearable
          >
          </el-input>
        </el-form-item>

        <el-form-item label="Email" prop="Email" v-if="mode == 'edit'">
          <el-input
            v-model="formData.Email"
            placeholder="Email"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item label="Address" prop="Address" v-if="mode == 'edit'">
          <el-input
            v-model="formData.Address"
            type="textarea"
            placeholder="Address"
            :autosize="{ minRows: 4, maxRows: 4 }"
            :style="{ width: '100%' }"
          ></el-input>
        </el-form-item>

        <div
          class="flex lg:space-x-0 space-y-2 lg:space-x-2 lg:space-y-0 lg:w-full lg:flex-row flex-col"
          v-if="mode === 'edit'"
        >
          <el-form-item
            label="Password"
            class="lg:w-1/2 w-full"
            prop="Password"
            :required="mode !== 'edit'"
          >
            <el-input
              v-model="formData.Password"
              placeholder="Password"
              clearable
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item
            label="Confirm Password"
            class="lg:w-1/2 w-full"
            prop="PasswordVerified"
            :required="mode !== 'edit'"
          >
            <el-input
              v-model="formData.PasswordVerified"
              placeholder="Confirm Password"
              clearable
              show-password
            ></el-input>
          </el-form-item>
        </div>

        <hr class="my-4" />
        <div class="w-full text-right">
          <div v-if="mode === 'edit'">
            <el-button type="primary" @click="submit" icon="el-icon-check">
              Submit
            </el-button>
            <el-button @click="cancel">Cancel</el-button>
          </div>
          <el-button
            type="primary"
            @click="editMode(true)"
            icon="el-icon-edit"
            v-else
          >
            Edit
          </el-button>
        </div>
      </el-form>
    </div>
  </WidgetWrapper>
</template>

<script>
import formService from '@/mixins/FormService'
import formHelper from './form-helper'
import WidgetWrapper from '@/components/WidgetWrapper'
// import { DxButton } from 'devextreme-vue'
// import { DxForm, DxSimpleItem, DxLabel } from 'devextreme-vue/form'

let service

export default {
  components: {
    WidgetWrapper
    // DxButton,
    // DxForm,
    // DxSimpleItem,
    // DxLabel
  },
  created() {
    service = new formService(this, formHelper, this.user.Id)
    formHelper.setUserId(this.user.Id)
  },
  async mounted() {
    this.loading = true
    this.formData = await service.initialFormData()
    this.setDefaultCustomerId()

    this.formData.Password = ''
    this.loading = false
  },
  data() {
    return {
      apiGetById: this.$appInfo.api.user.getById,
      apiPost: this.$appInfo.api.user.post,
      apiPut: this.$appInfo.api.user.put,
      formData: formHelper.getEmptyData(),
      validationRules: formHelper.getValidationRule(),
      roles: [],
      costumers: [],
      mode: 'view',
      isSubmit: false,
      loading: false
    }
  },
  methods: {
    editMode(val) {
      this.mode = val ? 'edit' : 'view'
    },
    setDefaultCustomerId() {
      if (this.isCustomer) {
        this.formData.CustomerName[0] = this.user.CustomerName
          ? this.user.CustomerName[0]
          : ''
      }
    },

    async cancel() {
      this.mode = 'view'
    },
    async submit() {
      this.$refs.elForm.validate(async (valid) => {
        if (valid) {
          try {
            this.loading = true
            this.isSubmit = true

            if (this.formData.Password === '') {
              //hapus property password jika kosong
              delete this.formData.Password
            }

            await service.submit(this.formData, false)

            // set mode to view only
            this.mode = 'view'
            this.$message.success('Data Saved')
            this.loading = false
          } catch (e) {
            this.loading = false
            this.$message.error(e)
            console.log(e)
          }
        } else {
          this.$message.warning('Please fill in the required data')
          this.loading = false
          return false
        }
      })
    },
    async fetchRole() {
      try {
        this.loading = true
        const res = await this.$axios.get(`${this.$appInfo.api.role.getAll}`)

        this.roles = res.data

        // filter customer role
        if (this.isCustomer) {
          this.roles = res.data.filter(
            (x) =>
              x.RoleName === 'Customer Staff' || x.RoleName === 'Customer Admin'
          )
        }

        this.loading = false
      } catch (e) {
        this.loading = false
        console.log(e)
      }
    },
    async fetchCustomer() {
      try {
        this.loading = true
        const res = await this.$axios.get(
          `${this.$appInfo.api.customer.getAll}`
        )
        this.costumers = res.data
        this.loading = false
      } catch (e) {
        this.loading = false
        console.log(e)
      }
    }
  },
  computed: {
    isCustomer() {
      return this.$store.state.auth.isCustomer
    },
    user() {
      return this.$store.state.auth.userData
    }
  },
  beforeRouteLeave(to, from, next) {
    if (!this.isSubmit && this.mode == 'edit') {
      const answer = window.confirm(
        'Do you really want to leave? you have unsaved changes!'
      )
      if (answer) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  }
}
</script>
